import React, { useContext, useState, useEffect } from "react";
import Footer from "../../Components/HomeComponents/Footer/Footer";
import Navbar from "../../Components/HomeComponents/Navbar/Navbar";
import Context from "../../Context/Context";
import wallet_i from "../../Assets/wallet_login_register.png";
import { BsEyeFill } from "react-icons/bs";
import styles from "./SignIn.module.scss";
import { sendRequest, vpassword } from "../../Helper/helper";
import validator from "validator";
import swal from "sweetalert";
import jwt_decode from "jwt-decode";
import ReCaptcha from "../../Components/ReCaptcha/ReCaptcha";
import { Link, useNavigate } from "react-router-dom";

const SignIn = ({ _redirect = "exchange" }) => {
  const [sp, setSp] = useState(false);
  const [_alert, set_alert] = useState({});
  const [submitBtn, setSubmitBtn] = useState(false);
  const [resetCaptcha, setResetCaptcha] = useState(false);
  const [captcha, setCaptcha] = useState();
  const [validate, setValidate] = useState({
    email: "",
    password: "",
  });
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const { states } = useContext(Context);
  const spHandler = () => (sp ? setSp(false) : setSp(true));

  const alertHandler = (key, val) => {
    let change = _alert;
    change[key] = val;
    set_alert({ ...change });
  };

  const validateHandler = (key, val) => {
    let change = validate;
    change[key] = val;
    setValidate({ ...change });
  };

  const getData = (key, val) => {
    let change = formData;
    change[key] = val;
    setFormData({ ...change });
    set_alert({});
    if (key === "email") {
      validateHandler(key, validator.isEmail(val));
    } else if (key === "password") {
      validateHandler(key, vpassword(val));
    }
  };

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate.email && formData.email && formData.password) {
      setSubmitBtn(true);
      const res = await sendRequest(
        {
          email: formData.email,
          password: formData.password,
          "g-recaptcha-response": captcha, 
        },
        "manage",
        "post"
      );
      try {
        res && setSubmitBtn(false);
        setResetCaptcha(true);
       // console.log("res=>", res);
        if (res.status === 200) {
          const decoded = jwt_decode(res.data);
          //console.log("user=>",decoded);
          localStorage.setItem("hideZero", decoded.hideZeroStatus);
          document.querySelector("form").reset();
          sessionStorage.setItem("user", JSON.stringify(res.data));
          localStorage.removeItem("Pages");
          navigate(`/${_redirect}`);
        } else if (res.status === 402) {
          swal(res.message);
        } else {
          swal(res.message);
        }
      } catch (err) {
        if (err) {
          swal(res.message, res.data);
        }
      }
    }else{
      if(!formData.email && !validate.email){
        alertHandler("email", "Please enter email !");
      }
      if(!formData.password){
        alertHandler("password", "Please enter password !");
      }
    }
  };

  const dmode = states.dmode;

  useEffect(() => {
    // window.scrollTo(0, 0)
  }, []);

  return (
    <div className={dmode ? `${styles.signin_l} signPage ligtMode` : `${styles.signin_l} signPage ligtMode`}>
      <Navbar />
      <div className={` padSecimporant flex-between container`}>
        <div class={`row`}>
        <div class={`col-sm-6`}>
        <div class={`${styles._signin}`}>
        <form onSubmit={handleSubmit} className="flex-start column">
          <h2 className="titleh2">BTRL Exchange- Manage</h2>
          <input
            onChange={(e) => getData("email", e.target.value)}
            type="email"
            placeholder="Email Address*"
          />
          <div className={styles.warning_note}>
            <p>
              {validate.email === false &&
                formData.email.length > 0 &&
                "Please fill your valid email id"}
            </p>
          </div>
          <div className={styles.warning_note}>
            <p>{_alert.email}</p>
          </div>
          <div className={`${styles.password} withIcon flex-between`}>
            <input
              onChange={(e) => getData("password", e.target.value)}
              type={sp ? "text" : "password"}
              placeholder="Password*"
            />
            <button
              type="button"
              onClick={spHandler}
              className={`${sp ? styles.eyea : styles.eye} flex-center`}
            >
              <BsEyeFill />
            </button>
          </div>
          <div className={styles.warning_note}>
            <p>
              {/* validate.password === false &&
                formData.password.length > 0 &&
                "Please fill your valid password" */}
            </p>
          </div>
          <div className={styles.warning_note}>
            <p>{_alert.password}</p>
          </div>
          <ReCaptcha
            checkCaptcha={setCaptcha}
            reset={resetCaptcha}
            setReset={setResetCaptcha}
          />
          <button
            type="submit"
            disabled={submitBtn}
            className={`${styles.signin_btn} btn`}
          >
            {submitBtn ? (
              <i className="fa fa-spinner fa-spin"></i>
            ) : (
              "Login Now"
            )}
          </button>
          <div className={`${styles.refer} flex-between gap-2 formBottomCOlor`}>
            <Link to="/signup">Don't have an account?</Link>
            <Link to="/forget-password">Forgot password?</Link>
          </div>
        </form>
      </div>
    </div>
    <div class="col-sm-6">
      
        <img src={wallet_i} alt="wallet" class="img-fluid" />
    </div>
  </div>
      </div>

      <Footer />
    </div>
  );
};

export default SignIn;
